export const RESERVATION_FORM_TYPES = Object.freeze({
  COMPLETE: 'Complete',
  UPDATE: 'Update',
});
